import { getDayExperience, getDayHotel } from './getDayProducts';

function uniqueById<T extends { id?: string | number }>(items: T[]): T[] {
  return items.filter(
    (item, index) => items.findIndex((other) => other.id === item.id) === index,
  );
}

// What the itinerary tab draws: the route between the start of each
// experience, then each product once, in day order.
export function getItineraryMarkers({
  days,
  experiencesMap,
  hotelsMap,
}: {
  days?: any[];
  experiencesMap: any;
  hotelsMap: any;
}) {
  const dayList = days ?? [];
  const experiences = uniqueById(
    dayList.map((day) => getDayExperience(day, experiencesMap)).filter(Boolean),
  );
  const hotels = uniqueById(
    dayList.map((day) => getDayHotel(day, hotelsMap)).filter(Boolean),
  );
  const programs = uniqueById(
    experiences.flatMap((experience) => experience.programs ?? []),
  );
  const linePoints = experiences
    .map((experience) => ({
      id: experience.id,
      lat: parseFloat(experience.startPosition?.lat),
      lng: parseFloat(experience.startPosition?.lon),
    }))
    .filter((point) => point.lat && point.lng);

  return { linePoints, experiences, hotels, programs };
}
